import tw, { styled } from 'twin.macro';

const HeadingResultHighlight = styled.div`
  ${tw`font-bold print:inline print:ml-1`}
`;

export default HeadingResultHighlight;
